import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";
import { routes } from "./routesConfig";
import { useAuthStore } from "../store/authStore";

export const AppRoutes = () => {
  const { isAuthenticated } = useAuthStore();

  return (
    <Routes>
      <Route
        path="/"
        element={
          isAuthenticated ? (
            <Navigate to="/home" replace />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

      {routes.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          element={
            route.isProtected ? (
              <ProtectedRoute>
                <route.component />
              </ProtectedRoute>
            ) : route.path === "/login" && isAuthenticated ? (
              <Navigate to="/home" replace />
            ) : (
              <route.component />
            )
          }
        />
      ))}
    </Routes>
  );
};
